import React, { useRef, useState } from 'react';
import FlexComponent from '../FlexComponent';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FieldArray } from 'formik';
import { InputMask } from 'primereact/inputmask';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Avatar } from 'primereact/avatar';
import { Toast } from 'primereact/toast';
import CosignerWorkHistory from './CosignerWorkHistory';
import CosignerAddressHistory from './CosignerAddressHistory';
import './form.css';
import { Divider } from 'primereact/divider';

function CoSignerInfo({ values, errors, touched, handleBlur, handleChange, setFieldValue }) {
    const toast = useRef(null);
    const [error, setError] = useState({});
    const [editingIndex, setEditingIndex] = useState(null);
    const [currentCosigner, setCurrentCosigner] = useState({
        co_borrower_first_name: '',
        co_borrower_middle_name: '',
        co_borrower_last_name: '',
        cb_DOB: null,
        cb_credit_score: '',
        cosigner_cell_phone_number: '',
        cosigner_email: '',
        cosigner_security_no: '',
        address_history: [],
        work_history: [],
        work_history_gap_explanation: '',
        do_you_have_second_job: '',
    });

    const handleAddClick = () => {
        if (validateCosignerEntry(currentCosigner)) {
            setFieldValue('cosigner_list', [...(values.cosigner_list || []), { ...currentCosigner }]);
            setCurrentCosigner({
                co_borrower_first_name: '',
                co_borrower_middle_name: '',
                co_borrower_last_name: '',
                cb_DOB: null,
                cb_credit_score: '',
                cosigner_cell_phone_number: '',
                cosigner_email: '',
                cosigner_security_no: '',
                address_history: [],
                work_history: [],
                work_history_gap_explanation: '',
                do_you_have_second_job: '',
            });
            setError({});
        }
    };

    const handleEditClick = (index) => {
        setEditingIndex(index);
    };

    const handleSaveEdit = (index) => {
        if (validateCosignerEntry(values.cosigner_list[index])) {
            setEditingIndex(null);
            setError({});
        }
    };

    const handleCancelEdit = () => {
        setEditingIndex(null);
        setError({});
    };

    const handleDeleteClick = (index, arrayHelpers) => {
        arrayHelpers.remove(index);
    };

    const handleInputChange = (index, field, value) => {
        const updatedCosignerList = [...(values.cosigner_list || [])];
        updatedCosignerList[index] = { ...updatedCosignerList[index], [field]: value };
        setFieldValue('cosigner_list', updatedCosignerList);
    };

    const handleNewEntryChange = (field, value) => {
        setCurrentCosigner((prev) => ({ ...prev, [field]: value }));
    };

    const validateCosignerEntry = (cosignerEntry) => {
        const errors = {};
        if (!cosignerEntry.co_borrower_first_name?.trim()) errors.co_borrower_first_name = true;
        if (!cosignerEntry.co_borrower_last_name?.trim()) errors.co_borrower_last_name = true;
        setError(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <div style={{ width: '100%', padding: '0.5rem 0 0 5.8%' }} id="cosignerId">
            <Toast ref={toast} />
            <div>
                <p style={{ fontSize: '28px', fontWeight: 'bold', padding: '0.75rem', fontFamily: "Barlow Semi Condensed" }}>
                    Let's collect cosigner information
                </p>
            </div>

            <div className="inputContainerDiv" style={{ textAlign: 'start', margin: '1rem', width: '30%' }}>
                <Dropdown
                    id="do_you_have_a_cosigner"
                    value={values.do_you_have_a_cosigner}
                    options={[
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                    ]}
                    style={{ width: '100%' }}
                    onChange={(e) => handleChange({ target: { name: 'do_you_have_a_cosigner', value: e.value } })}
                    showClear={values.do_you_have_a_cosigner}
                    onBlur={handleBlur}
                    placeholder="Do You have a Cosigner"
                />
            </div>

            {values.do_you_have_a_cosigner === 'Yes' && (
                <FieldArray name="cosigner_list">
                    {(arrayHelpers) => (
                        <>
                            {values.cosigner_list?.map((cosigner, index) => (
                                <FlexComponent
                                    key={index}
                                    style={{ background: 'white', margin: '1rem 0', padding: '1rem', borderRadius: '10px' }}
                                    gap="1rem"
                                    flexDirection="column"
                                >
                                    {editingIndex !== index ? (
                                        <FlexComponent alignItems="start" justifyContent="start" gap="1rem" style={{ textAlign: 'start' }}>
                                            <div>
                                                <Avatar
                                                    style={{ width: '4.5rem', color: 'white', background: '#EB4243' }}
                                                    label="CB"
                                                    size="xlarge"
                                                />
                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <p>{`${cosigner?.co_borrower_first_name || ''} ${cosigner?.co_borrower_last_name || ''}`}</p>
                                                <p>{cosigner?.cosigner_email || 'No Email'}</p>
                                                <p style={{ color: '#8C8C8C' }}>{cosigner?.cosigner_cell_phone_number || 'No Phone'}</p>
                                                <p>
                                                    <span style={{ fontSize: '22px', fontWeight: 'bold' }}>${cosigner?.cb_yearly_income || '0'}</span>
                                                    <span style={{ marginLeft: '.3rem' }}>Yearly</span>
                                                </p>
                                            </div>
                                            <Button type="button" onClick={() => handleEditClick(index)}>
                                                Edit
                                            </Button>
                                            <Button type="button" onClick={() => handleDeleteClick(index, arrayHelpers)}>
                                                Delete
                                            </Button>
                                        </FlexComponent>
                                    ) : (
                                        <FlexComponent flexDirection="column" gap="1rem" justifyContent="start" alignItems="start" style={{ width: '100%', boxShadow : "rgba(0, 0, 0, 0.2) 0px 4px 10px 4px", padding: "1rem" }}>
                                            <FlexComponent justifyContent="start" className="inputFlexContainer" gap="1rem" alignItems="start">
                                                <div className="inputContainerDiv" style={{ textAlign: 'start', width: '100%' }}>
                                                    <FlexComponent className="inputFlexContainer" gap="1rem" alignItems="start">
                                                        <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                            <InputText
                                                                value={cosigner.co_borrower_first_name || ''}
                                                                onChange={(e) => handleInputChange(index, 'co_borrower_first_name', e.target.value)}
                                                                style={{ width: '100%', border: error.co_borrower_first_name && '1px solid red' }}
                                                                placeholder="First Name"
                                                            />
                                                        </div>
                                                        <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                            <InputText
                                                                value={cosigner.co_borrower_middle_name || ''}
                                                                onChange={(e) => handleInputChange(index, 'co_borrower_middle_name', e.target.value)}
                                                                style={{ width: '100%' }}
                                                                placeholder="Middle Name"
                                                            />
                                                        </div>
                                                        <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                            <InputText
                                                                value={cosigner.co_borrower_last_name || ''}
                                                                onChange={(e) => handleInputChange(index, 'co_borrower_last_name', e.target.value)}
                                                                style={{ width: '100%', border: error.co_borrower_last_name && '1px solid red' }}
                                                                placeholder="Last Name"
                                                            />
                                                        </div>
                                                        <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                            <Calendar
                                                                value={cosigner.cb_DOB ? new Date(cosigner.cb_DOB) : null}
                                                                onChange={(e) => handleInputChange(index, 'cb_DOB', e.value)}
                                                                style={{ width: '100%' }}
                                                                placeholder="Date of Birth"
                                                                maxDate={new Date()}
                                                            />
                                                        </div>
                                                    </FlexComponent>
                                                </div>
                                            </FlexComponent>

                                            <FlexComponent className="inputFlexContainer" gap="1rem" alignItems="start">
                                                <div className="inputContainerDiv" style={{ width: '50%' }}>
                                                    <div className="p-inputgroup flex-1 login-input-div">
                                                        <span className="p-inputgroup-addon" style={{ background: 'white' }}>
                                                            +1
                                                        </span>
                                                        <InputMask
                                                            mask="(999) 999-9999"
                                                            value={cosigner.cosigner_cell_phone_number || ''}
                                                            onChange={(e) => handleInputChange(index, 'cosigner_cell_phone_number', e.target.value)}
                                                            style={{ width: '100%' }}
                                                            placeholder="Cell Phone Number"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '50%' }}>
                                                    <InputText
                                                        type="email"
                                                        value={cosigner.cosigner_email || ''}
                                                        onChange={(e) => handleInputChange(index, 'cosigner_email', e.target.value)}
                                                        style={{ width: '100%' }}
                                                        placeholder="Email"
                                                    />
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '50%' }}>
                                                    <Dropdown
                                                        id='MaritalStatus'
                                                        value={cosigner.MaritalStatus || ''}
                                                        options={[
                                                            { label: "Single", value: "Single" },
                                                            { label: "Married", value: "Married" },
                                                        ]}
                                                        style={{ width: '100%' }}
                                                        onChange={(e) => handleInputChange(index, 'MaritalStatus', e.target.value)}
                                                        showClear={values.MaritalStatus}
                                                        onBlur={handleBlur}
                                                        placeholder='Marital Status'
                                                    />
                                                </div>
                                            </FlexComponent>

                                            <FlexComponent justifyContent="start" className="inputFlexContainer" gap="1rem" alignItems="start">
                                                <div className="inputContainerDiv" style={{ width: '30%' }}>
                                                    <InputText
                                                        type="number"
                                                        value={cosigner.cb_credit_score || ''}
                                                        onChange={(e) => handleInputChange(index, 'cb_credit_score', e.target.value)}
                                                        style={{ width: '100%' }}
                                                        placeholder="Credit Score"
                                                    />
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '30%' }}>
                                                    <InputMask
                                                        value={cosigner.cosigner_security_no || ''}
                                                        onChange={(e) => handleInputChange(index, 'cosigner_security_no', e.target.value)}
                                                        style={{ width: '100%' }}
                                                        placeholder="SSN (000-00-0000)"
                                                        mask="999-99-9999"
                                                    />
                                                </div>
                                            </FlexComponent>

                                            <FlexComponent flexDirection="column" gap="1rem" alignItems="start" style={{ width: '100%' }}>
                                                <CosignerWorkHistory
                                                    values={values}
                                                    errors={errors}
                                                    touched={touched}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    setFieldValue={setFieldValue}
                                                    index={index}
                                                    isNewEntry={false}
                                                    handleNewEntryChange={(field, value) => handleInputChange(index, field, value)}
                                                    toast={toast}
                                                />
                                            </FlexComponent>

                                            <FlexComponent className="inputFlexContainer" flexDirection="column" gap="1rem" alignItems="start">
                                                <CosignerAddressHistory
                                                    values={values}
                                                    errors={errors}
                                                    touched={touched}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    setFieldValue={setFieldValue}
                                                    index={index}
                                                    isNewEntry={false}
                                                    currentCosigner={cosigner}
                                                    handleNewEntryChange={(field, value) => handleInputChange(index, field, value)}
                                                    toast={toast}
                                                />
                                            </FlexComponent>



                                            <FlexComponent gap="1rem" justifyContent="end">
                                                <Button type="button" onClick={() => handleSaveEdit(index)}>
                                                    Save
                                                </Button>
                                                <Button type="button" onClick={handleCancelEdit}>
                                                    Cancel
                                                </Button>
                                            </FlexComponent>
                                        </FlexComponent>
                                    )}
                                </FlexComponent>
                            ))}
                            <Divider style={{ border: "2px solid grey" }} />
                            <div style={{ background: 'white', padding: '1rem', borderRadius: '10px' }}>
                                <FlexComponent flexDirection="column" gap="1rem" alignItems="start">
                                    <FlexComponent className="inputFlexContainer" gap="1rem" alignItems="start">
                                        <div className="inputContainerDiv" style={{ textAlign: 'start', width: '100%' }}>
                                            <FlexComponent className="inputFlexContainer" gap="1rem" alignItems="start">
                                                <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                    <InputText
                                                        value={currentCosigner.co_borrower_first_name || ''}
                                                        onChange={(e) => handleNewEntryChange('co_borrower_first_name', e.target.value)}
                                                        style={{ width: '100%', border: error.co_borrower_first_name && '1px solid red' }}
                                                        placeholder="First Name"
                                                    />
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                    <InputText
                                                        value={currentCosigner.co_borrower_middle_name || ''}
                                                        onChange={(e) => handleNewEntryChange('co_borrower_middle_name', e.target.value)}
                                                        style={{ width: '100%' }}
                                                        placeholder="Middle Name"
                                                    />
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                    <InputText
                                                        value={currentCosigner.co_borrower_last_name || ''}
                                                        onChange={(e) => handleNewEntryChange('co_borrower_last_name', e.target.value)}
                                                        style={{ width: '100%', border: error.co_borrower_last_name && '1px solid red' }}
                                                        placeholder="Last Name"
                                                    />
                                                </div>
                                                <div className="inputContainerDiv" style={{ width: '100%' }}>
                                                    <Calendar
                                                        value={currentCosigner.cb_DOB ? new Date(currentCosigner.cb_DOB) : null}
                                                        onChange={(e) => handleNewEntryChange('cb_DOB', e.value)}
                                                        style={{ width: '100%' }}
                                                        placeholder="Date of Birth"
                                                        maxDate={new Date()}
                                                    />
                                                </div>
                                            </FlexComponent>
                                        </div>
                                    </FlexComponent>
                                    <FlexComponent className="inputFlexContainer" gap="1rem" alignItems="start">
                                        <div className="inputContainerDiv" style={{ width: '50%' }}>
                                            <div className="p-inputgroup flex-1 login-input-div">
                                                <span className="p-inputgroup-addon" style={{ background: 'white' }}>
                                                    +1
                                                </span>
                                                <InputMask
                                                    mask="(999) 999-9999"
                                                    value={currentCosigner.cosigner_cell_phone_number || ''}
                                                    onChange={(e) => handleNewEntryChange('cosigner_cell_phone_number', e.target.value)}
                                                    style={{ width: '100%' }}
                                                    placeholder="Cell Phone Number"
                                                />
                                            </div>
                                        </div>
                                        <div className="inputContainerDiv" style={{ width: '50%' }}>
                                            <InputText
                                                type="email"
                                                value={currentCosigner.cosigner_email || ''}
                                                onChange={(e) => handleNewEntryChange('cosigner_email', e.target.value)}
                                                style={{ width: '100%' }}
                                                placeholder="Email"
                                            />
                                        </div>
                                        <div className="inputContainerDiv" style={{ width: '50%' }}>
                                            <Dropdown
                                                id='MaritalStatus'
                                                value={currentCosigner.MaritalStatus || ''}
                                                options={[
                                                    { label: "Single", value: "Single" },
                                                    { label: "Married", value: "Married" },
                                                ]}
                                                style={{ width: '100%' }}
                                                onChange={(e) => handleNewEntryChange('MaritalStatus', e.target.value)}
                                                showClear={values.MaritalStatus}
                                                onBlur={handleBlur}
                                                placeholder='Marital Status'
                                            />
                                        </div>

                                    </FlexComponent>
                                    <FlexComponent className="inputFlexContainer" justifyContent="start" gap="1rem" alignItems="start">
                                        <div className="inputContainerDiv" style={{ width: '30%' }}>
                                            <InputText
                                                type="number"
                                                value={currentCosigner.cb_credit_score || ''}
                                                onChange={(e) => handleNewEntryChange('cb_credit_score', e.target.value)}
                                                style={{ width: '100%' }}
                                                placeholder="Credit Score"
                                            />
                                        </div>
                                        <div className="inputContainerDiv" style={{ width: '30%' }}>
                                            <InputMask
                                                value={currentCosigner.cosigner_security_no || ''}
                                                onChange={(e) => handleNewEntryChange('cosigner_security_no', e.target.value)}
                                                style={{ width: '100%' }}
                                                placeholder="SSN (000-00-0000)"
                                                mask="999-99-9999"
                                            />
                                        </div>
                                    </FlexComponent>

                                    <FlexComponent flexDirection="column" gap="1rem" alignItems="start" style={{ width: '100%' }}>
                                        <CosignerWorkHistory
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            index={values.cosigner_list?.length || 0}
                                            isNewEntry={true}
                                            currentCosigner={currentCosigner}
                                            handleNewEntryChange={handleNewEntryChange}
                                            toast={toast}
                                        />
                                    </FlexComponent>

                                    <FlexComponent className="inputFlexContainer" flexDirection="column" gap="1rem" alignItems="start">
                                        <CosignerAddressHistory
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            index={values.cosigner_list?.length || 0}
                                            isNewEntry={true}
                                            currentCosigner={currentCosigner}
                                            handleNewEntryChange={handleNewEntryChange}
                                            toast={toast}
                                        />
                                    </FlexComponent>


                                </FlexComponent>

                                <div style={{ textAlign: 'center', margin: '1rem' }}>
                                    <Button
                                        type="button"
                                        label="Save Cosigner"
                                        style={{
                                            borderRadius: '5px',
                                            fontSize: '16px',
                                            // padding: '5px 20px',
                                            border: '1px solid #E0E4EC',
                                            // background: 'white',
                                            // color: '#8C8C8C',
                                        }}
                                        onClick={handleAddClick}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </FieldArray>
            )}
        </div>
    );
}

export default CoSignerInfo;